export default "__VITE_ASSET__1557765f__"